import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuthStore } from '@/stores/authStore';

export function AuthCallbackPage() {
  const navigate = useNavigate();
  const { initializeSession, user } = useAuthStore();

  useEffect(() => {
    let cancelled = false;

    async function finishRedirect() {
      try {
        await initializeSession();
        if (cancelled) return;

        const nextUser = useAuthStore.getState().user ?? user;
        if (nextUser && !nextUser.onboardingCompleted) {
          navigate('/onboarding', { replace: true });
          return;
        }
        navigate('/dashboard', { replace: true });
      } catch (_error) {
        if (!cancelled) {
          navigate('/login', { replace: true });
        }
      }
    }

    void finishRedirect();

    return () => {
      cancelled = true;
    };
  }, [initializeSession, navigate, user]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="flex items-center gap-3 text-muted-foreground">
        <Loader2 className="h-5 w-5 animate-spin" />
        <span>Completing sign in…</span>
      </div>
    </div>
  );
}
